import GroupedReportView from '../../../components/reports/GroupedReportView';

export function ComprehensiveIncomeReport() {
  return (
    <GroupedReportView
      title="Statement of Comprehensive Income"
      description="Net Surplus/(Deficit) for the period plus Other Comprehensive Income (asset revaluation surplus movements, not posted to the GL) equals Total Comprehensive Income."
      endpoint="/reports/consolidated/comprehensive-income"
      filters={['dateRange']}
      supportsComparative
      xlsx
    />
  );
}
